import { CreditCard, Clock, CheckCircle, XCircle } from 'lucide-react';
import { StatCard } from '@/components/stat-card';
import { PaymentTable } from '@/components/payment-table';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { useDashboardStats } from '@/hooks/use-dashboard-stats';

export function DashboardPage() {
  const { stats, recentPayments, isLoading, error } = useDashboardStats();

  if (isLoading) {
    return (
      <div className="space-y-6">
        <div>
          <h2 className="text-2xl font-bold text-slate-900">Dashboard</h2>
          <p className="mt-1 text-sm text-slate-500">Loading...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="space-y-6">
        <div>
          <h2 className="text-2xl font-bold text-slate-900">Dashboard</h2>
          <p className="mt-2 rounded-md bg-red-50 px-4 py-3 text-sm text-red-700">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-slate-900">Dashboard</h2>
        <p className="mt-1 text-sm text-slate-500">
          PayNow reconciliation overview — auto-refreshes every 10s
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard title="Total Payments" value={stats.total} icon={CreditCard} iconClassName="bg-slate-100" />
        <StatCard title="Pending" value={stats.pending} icon={Clock} iconClassName="bg-amber-100" />
        <StatCard title="Paid / Completed" value={stats.paid} icon={CheckCircle} iconClassName="bg-green-100" />
        <StatCard title="Failed / Cancelled" value={stats.failed} icon={XCircle} iconClassName="bg-red-100" />
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Recent Payments</CardTitle>
        </CardHeader>
        <CardContent className="p-0 pb-2">
          <PaymentTable payments={recentPayments} compact />
        </CardContent>
      </Card>
    </div>
  );
}
